import { useEffect, useState, lazy, Suspense } from "react";
import { api } from "@/lib/api";
import { resolveImageUrl, buildSrcSet } from "@/components/ImageUpload";

const StoryViewer = lazy(() => import("@/components/StoryViewer"));

export function StoriesBar() {
  const [stories, setStories] = useState([]);
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    let cancelled = false;
    Promise.all([
      api.get("/articles").then((r) => r.data).catch(() => []),
      api.get("/songs").then((r) => r.data).catch(() => []),
    ]).then(([articles, songs]) => {
      if (cancelled) return;
      const fromNews = (articles || [])
        .filter((a) => a.cover_image && a.slug)
        .map((a) => ({ id: `n-${a.id}`, image: a.cover_image, image_alt: a.cover_image_alt || a.title, title: a.title, target: `/noticias/${a.slug}` }));
      const fromSongs = (songs || [])
        .filter((s) => s.cover_image && s.slug)
        .map((s) => ({ id: `s-${s.id}`, image: s.cover_image, image_alt: s.cover_image_alt || s.song, title: `${s.song} — ${s.artist}`, target: `/canciones/${s.slug}` }));
      const pool = [...fromNews, ...fromSongs];
      // Barajado Fisher-Yates (una sola vez) y tomamos 7.
      for (let i = pool.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [pool[i], pool[j]] = [pool[j], pool[i]];
      }
      setStories(pool.slice(0, 7));
    });
    return () => { cancelled = true; };
  }, []);
  if (!stories.length) return null;

  return (
    <section className="border-b border-black/10 bg-white/70 backdrop-blur-sm" data-testid="stories-bar">
      <div className="mx-auto max-w-[1400px] px-4 md:px-10 py-4">
        <div className="flex gap-5 overflow-x-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {stories.map((s, i) => (
            <button key={s.id} onClick={() => setOpenIndex(i)} className="shrink-0 group" data-testid={`story-${i}`}>
              <span className="block rounded-full p-[3px] bg-gradient-to-tr from-[#2A00D9] via-[#6f57ff] to-[#B4D844] transition-transform duration-300 group-hover:scale-105">
                <span className="block rounded-full p-[2px] bg-white">
                  <span className="block w-16 h-16 md:w-[72px] md:h-[72px] rounded-full overflow-hidden bg-[#F3F2EE]">
                    {s.image ? <img src={resolveImageUrl(s.image)} srcSet={buildSrcSet(s.image)} sizes="72px" alt={s.title} width={72} height={72} loading="lazy" decoding="async" className="w-full h-full object-cover" /> : null}
                  </span>
                </span>
              </span>
              <span className="block text-[11px] leading-tight text-center mt-1.5 w-16 md:w-[72px] truncate text-[#1A1A1A]">{s.title}</span>
            </button>
          ))}
        </div>
      </div>

      {openIndex !== null && (
        <Suspense fallback={null}>
          <StoryViewer stories={stories} index={openIndex} setIndex={setOpenIndex} onClose={() => setOpenIndex(null)} />
        </Suspense>
      )}
    </section>
  );
}
